import { AfterContentInit, Component, ContentChildren, ElementRef, Input, OnDestroy, OnInit, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { IconConfig } from '../../core/icon';

@Component({
    selector: 'rosie-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnDestroy, OnInit {
  iconColor: string;
  @ContentChildren('customContent') content: QueryList<ElementRef>;
  @Input() disabled = false;
  @Input() customDisabledClass = 'disabled';
  @Input() translationKey = 'COMMON.OK';
  @Input() customClass = 'btn-primary';
  @Input() customType = 'submit';
  @Input() inProgress = false;
  @Input() darkLoader = false;
  @Input() fullWidth = true;
  @Input() iconSuffixConfig: IconConfig;
  @Input() iconPrefix: string = '';
  @Input() iconPrefixConfig: IconConfig;
  @Input() spinnerColor = { outer: 'white', inner: '#954fc6' };


  constructor() {
  }

  get isDisabled(): boolean {
    return this.disabled === true;
  }

  get hasCustomClass(): boolean {
    return !!this.customClass;
  }

  get hasCustomType(): boolean {
    return !!this.customType;
  }

  get activeConfig(): IconConfig {
    return this.iconSuffixConfig || this.iconPrefixConfig;
  }

  get buttonClasses() {
    return {
      'w-100': this.fullWidth,
      [this.customDisabledClass]: this.isDisabled,
      'in-progress': this.inProgress
    };
  }

  ngOnInit(): void {
    this.iconColor = this.activeConfig?.color
  }

  ngOnDestroy(): void {
  }
}


